module.exports = __webpack_public_path__ + "static/bio-854d4c5b879b029ea6bb69bb775015f2.png";